export const data = [
	{
		name: 'Page A',
		pv: 14,
	},
	{
		name: 'Page B',
		pv: 21,
	},
	{
		name: 'Page C',
		pv: 32,
	},
	{
		name: 'Page D',
		pv: 33,
	},
	{
		name: 'Page E',
		pv: 12,
	},
	{
		name: 'Page F',
		pv: 51,
	},
	{
		name: 'Page G',
		pv: 77,
	},
	{
		name: 'Page H',
		pv: 65,
	},
	{
		name: 'Page I',
		pv: 54,
	},
	{
		name: 'Page J',
		pv: 88,
	},
	{
		name: 'Page K',
		pv: 11,
	},
	{
		name: 'Page L',
		pv: 88,
	},
	{
		name: 'Page N',
		pv: 44,
	},
	{
		name: 'Page M',
		pv: 99,
	},
]

export const getIntroOfPage = (label: any) => {
	if (label === 'Page A') {
		return "Page A is about men's clothing"
	}
	if (label === 'Page B') {
		return "Page B is about women's dress"
	}
	if (label === 'Page C') {
		return "Page C is about women's bag"
	}
	if (label === 'Page D') {
		return 'Page D is about household goods'
	}
	if (label === 'Page E') {
		return 'Page E is about food'
	}
	if (label === 'Page F') {
		return 'Page F is about baby food'
	}
	return ''
}
